import I18n from 'i18n'
import { takeLatest, call, put } from 'redux-saga/effects'

import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import { ActionWithPayload } from 'helpers/redux-actions.helper'
import externalCourseParticipantsList, {
  GetListResponse,
} from 'api/administration/externalCourseParticipants/GetList'
import destroyManyCertificates from 'api/administration/externalCourseCertificates/DestroyMany'
import {
  DESTROY_EXTERNAL_COURSE_CERTIFICATES,
  DestroyExternalCourseCertificatesPayload,
} from '../../actions/externalCourseCertificate.action'
import { Actions } from '../../actions/externalCourseParticipant.action'

function destroyExternalCourseCertificates(ids: (string | number)[]) {
  return destroyManyCertificates(ids)
}

const pattern = DESTROY_EXTERNAL_COURSE_CERTIFICATES

export type DestroyExternalCourseCertificatesAction = ActionWithPayload<
  typeof pattern,
  DestroyExternalCourseCertificatesPayload
>

function* destroyExternalCourseCertificatesSaga(
  action: DestroyExternalCourseCertificatesAction
) {
  try {
    const { ids, externalCourseId, params, callback } = action.payload
    if (ids.length) yield call(destroyExternalCourseCertificates, ids)
    SuccessToast(I18n.t('administration.toastMessages.deleteSuccess_plural'))
    if (externalCourseId) {
      yield put(Actions.setLoading(true))
      const resList: GetListResponse = yield call(
        externalCourseParticipantsList,
        externalCourseId,
        params
      )
      callback && callback(resList)
      const { data, total, perPage: resPerPage } = resList
      yield put(
        Actions.setAdministrationListSuccess(
          data,
          total,
          resPerPage,
          params?.sort
        )
      )
    }
  } catch (error) {
    yield put(Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.deleteError_plural'))
    console.error(error)
  }
}

export function* externalDestroyExternalCourseCertificatesSaga() {
  yield takeLatest(pattern, destroyExternalCourseCertificatesSaga)
}
